import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSkyContext } from '../store/provider';
import { AccountCircle } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_URL } from '../constants';
import { SettingOutlined } from '@ant-design/icons';
import airplane from '../assets/paper-plane.png';


const Header: React.FC = () => {
  const navigate = useNavigate();
  const skyContext = useSkyContext();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  let closeTimeoutId: any;

  useEffect(() => {
    setIsLoggedIn(skyContext.isAuthenticated);
  }, [skyContext.isAuthenticated]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };



  const handleLogs = () => {
    handleClose();
    navigate('/logs');
  };

  const handleLogout = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${DEFAULT_URL}logout`,
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      });

      if (response.status === 200) {
        handleClose();
        skyContext.setFields({ user: null });
        navigate('/signin');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };
  const handleMouseLeave = () => {
    console.log('mouse leave');
    closeTimeoutId = setTimeout(handleClose, 1000); // Store the timeout ID
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    clearTimeout(closeTimeoutId); // Clear the timeout when the mouse enters
    setAnchorEl(event.currentTarget);
  };

  const keepMenuAlive = () => {
    clearTimeout(closeTimeoutId); // Clear the timeout when the mouse enters
  }

  return isLoggedIn ? (
    <div className="header">
      <ul>
        <li style={{ float: 'right' }}>
          <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
          >
            <img src={airplane} width="auto" height="25" onMouseEnter={handleMenu}/>

          </IconButton>
          <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}
                      onMouseLeave={handleMouseLeave}
                      onMouseEnter={keepMenuAlive}
            >My account</MenuItem>
            <MenuItem onClick={handleLogs}
                      onMouseLeave={handleMouseLeave}
                      onMouseEnter={keepMenuAlive}
            >View Logs</MenuItem>
            <MenuItem onClick={handleLogout}
                      onMouseLeave={handleMouseLeave}
                      onMouseEnter={keepMenuAlive}
            >Logout</MenuItem>
          </Menu>
        </li>
        <li style={{ float: 'right' }}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
          >
            <SettingOutlined style={{fontSize: '24px'}}/>

          </IconButton>
          <Typography variant="subtitle1" component="span">
            Hello {skyContext?.user?.username}
          </Typography>
        </li>
      </ul>
    </div>
  ) : null;
};

export default Header;
